import React, {useEffect} from 'react';
import { injectIntl, FormattedHTMLMessage } from 'gatsby-plugin-intl';

import { FirstScreen, H1, Tagline, Main, MostUsed, MostUsedTitle, MostUsedList, SideBar, SideMenu, MenuLink } from './FirstScreen.styled';


import { Cell,Grid,Container } from '../blockComponents';
import DownloadLink from '../styledComponents/DownloadLink';
import ButtonWithIconTransparent from '../styledComponents/ButtonWithIconTransparent';

function MainScreen({ 
    intl,
    refs,
    handleCLick,
    togglePopupScreen
    }) {

    const mainRef = refs['firstScreen'];

    const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0
    }

    useEffect(() => {
        const header = document.getElementById('pageHeader');
        const handleIntersectionMain = function(entries) {
            entries.forEach((entry) => {
                if (entry.intersectionRatio > 0) {
                    if (!header.classList.contains('dark')) {
                        header.classList.add('dark');
                    }
                } else {
                    if (header.classList.contains('dark')) {
                        header.classList.remove('dark');
                    }
                }
            });
        };

        const observerMain = new IntersectionObserver(handleIntersectionMain, options);
        if (mainRef.current) {
            observerMain.observe(mainRef.current);
        }
        

        return () => observerMain.disconnect();
    }, [mainRef, options]);
        
    return (
        <FirstScreen ref={mainRef}>
            <SideBar>
                <SideMenu>
                    <li><MenuLink onClick={() => handleCLick('brandSection')}>{intl.formatMessage({ id: 'brand_title' })}</MenuLink></li>
                    <li><MenuLink onClick={() => handleCLick('productTalkSection')}>{intl.formatMessage({ id: 'productTalk_title' })}</MenuLink></li>
                    <li><MenuLink onClick={() => handleCLick('logoSection')}>{intl.formatMessage({ id: 'MainMenu_1' })}</MenuLink></li>
                    <li><MenuLink onClick={() => handleCLick('colorSection')}>{intl.formatMessage({ id: 'MainMenu_2' })}</MenuLink></li>
                    <li><MenuLink onClick={() => handleCLick('typographySection')}>{intl.formatMessage({ id: 'MainMenu_3' })}</MenuLink></li>
                    <li><MenuLink onClick={() => handleCLick('devicesSection')}>{intl.formatMessage({ id: 'MainMenu_4' })}</MenuLink></li>
                    <li><MenuLink onClick={() => handleCLick('worksSection')}>{intl.formatMessage({ id: 'MainMenu_6' })}</MenuLink></li>
                    <li><MenuLink onClick={() => handleCLick('merchSection')}>{intl.formatMessage({ id: 'MainMenu_7' })}</MenuLink></li>
                    <li><MenuLink onClick={() => handleCLick('equipmentSection')}>{intl.formatMessage({ id: 'MainMenu_8' })}</MenuLink></li>
                    <li><MenuLink onClick={() => handleCLick('designSection')}>{intl.formatMessage({ id: 'MainMenu_10' })}</MenuLink></li>
                    <li><MenuLink onClick={() => handleCLick('designConstructorSection')}>{intl.formatMessage({ id: 'designConstr_title' })}</MenuLink></li>
                    <li><MenuLink onClick={() => handleCLick('iconsSection')}>{intl.formatMessage({ id: 'MainMenu_9' })}</MenuLink></li>
                </SideMenu>
            </SideBar>
            <Main>
                <Container>
                    <Grid>
                        <Cell col={12} colXl={10} colXxl={8} leftXl={2} leftXxl={3}>
                            <H1>{intl.formatMessage({ id: 'firstScreenTitle' })}</H1>  
                            <Tagline><FormattedHTMLMessage id="firstScreen_1" /></Tagline>
                            {/* Here goes Popup button */}
                            <ButtonWithIconTransparent onClick={() => togglePopupScreen()}>
                                {intl.formatMessage({ id: 'popup_brand_essence_button' })}
                            </ButtonWithIconTransparent>
                            <MostUsed>
                                <MostUsedTitle>{intl.formatMessage({ id: 'firstScreenUsed' })}</MostUsedTitle>
                                <MostUsedList>
                                    <li>
                                        <DownloadLink href="https://drive.google.com/drive/folders/1dxGJv6VjJJlFrXY8uljO32oF2Rg7lX6I?usp=sharing" title={intl.formatMessage({ id: 'firstScreenMenu1' })}></DownloadLink>
                                    </li>
                                    <li>
                                        <DownloadLink href="https://drive.google.com/drive/folders/1zzj6uCTS0EZ2_SAlozeTO_d64DGFzATt?usp=sharing" title={intl.formatMessage({ id: 'firstScreenMenu2' })}></DownloadLink>
                                    </li>
                                    <li>
                                        <DownloadLink href="https://drive.google.com/drive/folders/1RP_9-wkJG5UMBNWjny9yO7Lf80gWyD2A?usp=sharing" title={intl.formatMessage({ id: 'firstScreenMenu3' })}></DownloadLink>
                                    </li>
                                    <li>
                                        <DownloadLink href="https://drive.google.com/drive/folders/1IoyjAwIrcxVRZ43vUh4r823u7OCu7grQ?usp=sharing" title={intl.formatMessage({ id: 'firstScreenMenu4' })}></DownloadLink>
                                    </li>
                                    <li>
                                        <DownloadLink href="https://drive.google.com/drive/folders/1jQjKTQ1__MpiGYeegWnm6yg-Dcxpvzzc?usp=sharing" title={intl.formatMessage({ id: 'firstScreenMenu5' })}></DownloadLink>
                                    </li>
                                    <li>
                                        <DownloadLink href="https://drive.google.com/drive/folders/1vDD9ISB7ufAn2YirOAdLt2sZwutFxT3L?usp=sharing" title={intl.formatMessage({ id: 'firstScreenMenu6' })}></DownloadLink>
                                    </li>
                                </MostUsedList>
                            </MostUsed>
                        </Cell>
                    </Grid>
                </Container>
            </Main>
        </FirstScreen>
    )
}

export default injectIntl(MainScreen)